import React from 'react';
import parse from 'html-react-parser';
import { subjectTypes } from '../../@types/entities/subjects.entity';
import { WrapIcon, Container, TextContainer } from './styles';
import Dice from '../../assets/icons/dice';

export type IGames = {
  content: string;
  color: 10 | 20 | 30 | 40 | 50;
  subject: subjectTypes | string;
};

export default function GamesAndPlay({ color, content, subject }: IGames) {
  return (
    <Container $color={color} $subject={subject}>
      <TextContainer $color={50} $subject={subject}>
        <WrapIcon $color={20} $subject={subject}>
          <Dice />
        </WrapIcon>
        {parse(content)}
      </TextContainer>
    </Container>
  );
}
